<script setup>
import { useRoute } from 'vue-router';
import { useFunctionGetter } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const route = useRoute();
const branch = useFunctionGetter('branches/getBranch', route.params.id);
</script>

<template>
  <WootReports
    v-if="branch && branch.id"
    :key="branch.id"
    type="branch"
    getter-key="branches/getBranches"
    action-key="branches/get"
    :selected-item="branch"
    :download-button-label="$t('BRANCH_REPORTS.DOWNLOAD_BRANCH_REPORTS')"
    :report-title="$t('BRANCH_REPORTS.HEADER')"
    has-back-button
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
